import DatabaseModel from './DatabaseModel.js';

var Oficina = Object.create(DatabaseModel);

Oficina.model = 'oficina';

export default Oficina;